import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';

import { LogoHeader } from '../../../containers/Components/index'

class Training extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
    };
    this.user_name = "";
    this.pwd = "";
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    // let slider_count = 4;
    // if (window.innerWidth < 520) {
    //   slider_count = 4;
    // }

    return (
      <div className="app flex-row font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />
        
        <div className="app-body p-0 m-0 width-100vw mt-5 ">
            <Container className = "background-white" fluid>
               <Row className = "about_page_gradient mt-3 ">
                 <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                 </Col>
                 <Col xs="6" sm="6" lg="2">
                  <h5 className = "m-3 text-white"> Training </h5>
                 </Col>
                </Row>
                <Row>
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col xs="12" sm="12" lg="8">
                    <h6 className = "mt-5 pt-2 line-height-h">
                      Corporate training is evolving, with powerful tools, such as augmented reality (AR) 
                      and virtual reality (VR), becoming the norm. Both AR and VR offer employee simulations, 
                      scenarios and information in a secure, risk-free environment.                    
                     </h6>
                    <h6 className = "mt-4 line-height-h">
                      The demand for AR and VR in corporate training has caused a dramatic increase in 
                      the global market. Statistics show market growth is now projected to reach $2.8 
                      billion by 2023.                    
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      There are several benefits to using AR and VR for professional development: <br></br>
                      1. They make training more innovative and enjoyable. <br></br>
                      2. They create experiences that are impossible in any other form of training. <br></br>
                      3. They teach through practical simulation rather than theoretical concepts. <br></br>
                      4. They offer a practice playground that encourages users to learn from their mistakes. <br></br>
                      5. They encourage employees to explore at their own pace and in their own style. <br></br>
                    </h6>
                    <h6 className = "mt-4 line-height-h">
                      Check out our ever expanding Training templates:
                    </h6>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
                <Row className = "mt-5">
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                  <Col className = "mb-5 pb-5" xs="12" sm="12" lg="8">
                    <Row>
                      <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                      </Col>
                      <Col className ="text-right" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3" > Template 1 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col className ="text-left" xs="6" sm="6" lg="4">
                        <img alt="" className ="img-width-100" src = "../assets/img/logo.png" />
                        <h6 className = "text-center mt-3"> Template 2 </h6>
                        <Row>
                          <Col className="text-left mt-4 mb-5">
                            <Button color="link" className= "text-left text-dark ml-2 mr-2 px-0 pb-2">Descriptions and details</Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>  
                  <Col className = "d-md-down-none" xs="6" sm="6" lg="2">
                  </Col>
                </Row>
  
            </Container>
        </div>
        </React.Fragment>
      </div>
    );
  }
}

export default Training;



// WEBPACK FOOTER //
// ./src/views/Pages/Training/Training.js